export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      group
      createdAt
      staffId
    }
  }
`;

export const createTextractJob = /* GraphQL */ `
  mutation CreateTextractJob(
    $input: CreateTextractJobInput!
    $condition: ModelTextractJobConditionInput
  ) {
    createTextractJob(input: $input, condition: $condition) {
      id
      group
      textractJobTenantId
      owner
      userId
      key
      fileName
      week
      year
      jobId
      jobStatus
      type
      isProcessed
      isProcessedS
      customerSubType
      metadataCreationDate
      metadataModificationDate
      metadataYear
      metadataWeek
      timeZone
      createdAt
      updatedAt
      automatedCoachingSendTime
    }
  }
`;
